import { api } from './api';
import type { ApiResponse, Pagination, Notification } from '../types';

export interface NotificationsListResponse {
  notifications: Notification[];
  pagination: Pagination;
  unread_count: number;
}

export interface NotificationsParams {
  page?: number;
  limit?: number;
  unread_only?: boolean;
  type?: string;
}

export const notificationService = {
  // 通知一覧取得
  getNotifications: async (params?: NotificationsParams): Promise<ApiResponse<NotificationsListResponse>> => {
    const response = await api.get('/notifications', { params });
    return response.data;
  },

  // 通知を既読にする
  markAsRead: async (notificationId: string): Promise<ApiResponse<{ message: string }>> => {
    const response = await api.put(`/notifications/${notificationId}/read`);
    return response.data;
  },

  // 全通知を既読にする
  markAllAsRead: async (): Promise<ApiResponse<{ message: string }>> => {
    const response = await api.post('/notifications/read-all');
    return response.data;
  },
};
